
import Vue from 'vue'
import VueRouter from 'vue-router'
import CiePayment from '../views/CiePayment'
import Forbidden from '../views/Forbidden'

Vue.use(VueRouter)

const routes = [
  {
    path: "/",
    redirect: "/reference"
  },
  {
    path: '/reference',
    name: 'reference',
    component: CiePayment
  },
  {
    path :'*',
    redirect: "/forbidden"
},
  {
    path: '/forbidden',
    name: 'Forbidden',
    component: Forbidden
  },
]

const router = new VueRouter({
  base: process.env.BASE_URL,
  mode: 'history',
  routes
})

export default router